import { render, staticRenderFns } from "./list-diamante-carrito.vue?vue&type=template&id=0ddd6756"
import script from "./list-diamante-carrito.vue?vue&type=script&lang=js"
export * from "./list-diamante-carrito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports